import React from 'react';

import Right from "./Right";
import Panel from "./Panel";

class SettingsPage extends React.Component {
	render(){
		
		return (
                <Right title={"Specielle indstillinger"} token={this.props.auth} lang={this.props.lang}>
                </Right>
                );
	}
}

export default SettingsPage;


// WEBPACK FOOTER //
// ./src/components/SettingsPage.js